$(document).ready(function () {

  // Product template -> Tier table
  var $productContainer = $('.product-template__container');
  if($productContainer.length > 0){
    var productJson = JSON.parse(
      document.getElementById('ProductJson--' + $productContainer.data('section-id')).innerHTML
    );

    var productVariant = productJson.variants;
    var current_variant = parseInt($('.product__info-wrapper').find('.product-form [name="id"]').val());
    
    $.each(productVariant, function (key, value) {
      var variant_id = value.id;
      if (current_variant == variant_id){
        var variant_price = value.price;
        tier_table(variant_price);
        return false;
      }
    });

  }
  
  $('variant-radios .product-form__input input').click(function () {

    setTimeout(function () {
      var selected_variant_id = parseInt($('.product__info-wrapper').find('.product-form [name="id"]').val());
      console.log(selected_variant_id);
      $.each(productVariant, function (key, value) {
        var variant_id = value.id;
        if (selected_variant_id == variant_id){
          var variant_price = value.price;
          tier_table(variant_price);
          return false;
        }
      });
    }, 1000);
    
  });

  // Product template -> Upsell function
  $('.product-upsell-list .product-form__variants').change(function () {
    var selected_variant = $(this).find('option:selected').val();
    $(this).closest('.product-upsell-cell').find('input.jq-upsell').attr('data-id', selected_variant);
    
  });
  $(document).on('click', '.product__info-wrapper .product-form__buttons .product-form__submit', function() {
    var $parentwrapper = $(this).closest('.product__info-wrapper');
    var $addToCartBtn = $parentwrapper.find('.product-form__buttons .product-form__submit');
    var i = 0;
    var items = [];
      
    if($parentwrapper.find('.product-upsell-list').length > 0){
      $.each($parentwrapper.find('.product-upsell-cell'), function(){
        var $input = $(this).find('input.jq-upsell');
        var variant_id = $input.data('id');        
        var variant_quantity = $(this).find('quantity-input input').val();
        
        if($input.prop('checked')){
          var item = {
            quantity: variant_quantity,
            id: variant_id
          };
          items.push(item);

          i++;
        }
      });
    }
    if(items.length > 0){
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: false,
        data: {
          items: items
        },
        dataType: 'json',
        error: function(data) {
          console.log('product unavailable');
        },
        success: function (data) {
          console.log('Checked Upsell Successfully!');
        },
        cache: false
      });
    }
  });

});

function tier_table(product_price) {
  var tier_sale1 = parseInt($('.tier-discount-table table tbody tr:first-child td.tier--sale_percent').text());
  var tier_sale2 = parseInt($('.tier-discount-table table tbody tr:nth-child(2) td.tier--sale_percent').text());
  var tier_sale3 = parseInt($('.tier-discount-table table tbody tr:nth-child(3) td.tier--sale_percent').text());
  var tier_sale4 = parseInt($('.tier-discount-table table tbody tr:nth-child(4) td.tier--sale_percent').text());
  var tier_sale5 = parseInt($('.tier-discount-table table tbody tr:nth-child(5) td.tier--sale_percent').text());
  var tier_sale6 = parseInt($('.tier-discount-table table tbody tr:nth-child(6) td.tier--sale_percent').text());
  var tier_sale_price1 = product_price * (100 - tier_sale1) / 100;
  var tier_sale_price2 = product_price * (100 - tier_sale2) / 100;
  var tier_sale_price3 = product_price * (100 - tier_sale3) / 100;
  var tier_sale_price4 = product_price * (100 - tier_sale4) / 100;
  var tier_sale_price5 = product_price * (100 - tier_sale5) / 100;
  var tier_sale_price6 = product_price * (100 - tier_sale6) / 100;
  
  var pro_tier_sale_price1 = formatMoney(tier_sale_price1,window.Shopify.money_format);
  var pro_tier_sale_price2 = formatMoney(tier_sale_price2,window.Shopify.money_format);
  var pro_tier_sale_price3 = formatMoney(tier_sale_price3,window.Shopify.money_format);
  var pro_tier_sale_price4 = formatMoney(tier_sale_price4,window.Shopify.money_format);
  var pro_tier_sale_price5 = formatMoney(tier_sale_price5,window.Shopify.money_format);
  var pro_tier_sale_price6 = formatMoney(tier_sale_price6,window.Shopify.money_format);

  $('.tier-discount-table table tbody tr:first-child td.tier--sale_price').text(pro_tier_sale_price1);
  $('.tier-discount-table table tbody tr:nth-child(2) td.tier--sale_price').text(pro_tier_sale_price2);
  $('.tier-discount-table table tbody tr:nth-child(3) td.tier--sale_price').text(pro_tier_sale_price3);
  $('.tier-discount-table table tbody tr:nth-child(4) td.tier--sale_price').text(pro_tier_sale_price4);
  $('.tier-discount-table table tbody tr:nth-child(5) td.tier--sale_price').text(pro_tier_sale_price5);
  $('.tier-discount-table table tbody tr:nth-child(6) td.tier--sale_price').text(pro_tier_sale_price6);
}

function formatMoney(cents) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "${{amount}}";
  var withoutZero = arguments.length > 2 ? arguments[2] : undefined;

  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ",";
    decimal = decimal || ".";

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split(".");
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : "";

    if (withoutZero) {
      centsAmount = centsAmount.replace(/[\.,]0{2}/, "");
    }

    return dollarsAmount + centsAmount;
  }

  switch (format.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;

    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;

    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;

    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;

    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;

    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
  }

  return format.replace(placeholderRegex, value);
}